import { ReactNode } from "react";
import { Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

interface PclHeaderCardBase {
  label: string;
  icon: string;
  buttonText: string;
  additionalContent?: ReactNode;
}

interface PclCardNavigationProps extends PclHeaderCardBase {
  linkPath: string;
  onClick?: never;
}

interface PclCardModalProps extends PclHeaderCardBase {
  onClick: () => void;
  linkPath?: never;
}

const PclHeaderCard = ({
  label,
  icon,
  buttonText,
  linkPath,
  onClick,
  additionalContent,
}: PclCardModalProps | PclCardNavigationProps) => {
  return (
    <Col xs={12} sm={6} lg={2} className="text-center border-0">
      <img
        src={icon}
        className="border-bottom border-warning border-5"
        height="150px"
        alt={`${label} Logo`}
      />
      <h5 className="text-uppercase fw-bold text-primary">{label}</h5>

      {linkPath && (
        <Link to={linkPath}>
          <Button variant="warning">{buttonText}</Button>
        </Link>
      )}

      {onClick && (
        <Button variant="warning" onClick={onClick}>
          {buttonText}
        </Button>
      )}

      {additionalContent}
    </Col>
  );
};
export default PclHeaderCard;
